import React from 'react';
import './ComingSoonAppSection.css';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGooglePlay, faAppStoreIos } from '@fortawesome/free-brands-svg-icons';
import { faMobileAlt } from '@fortawesome/free-solid-svg-icons'; // added mobile icon


const ComingSoonAppSection = () => {
    return (
      <section className="coming-soon-section">
        <div className="app-section-content">
          <div className="mockup-container">
            <FontAwesomeIcon icon={faMobileAlt} className="app-mockup-icon" />
          </div>
  
          <div className="app-info">
            <h2>Coming Soon to Your Mobile!</h2>
            <p>
              Access verified pharmacies, search for essential drugs, and enjoy peace of mind, all in one simple app.
            </p>
  
            <ul className="feature-list">
              <li>🔍 Search for drugs by name or category</li>
              <li>✅ Verified pharmacy listings near you</li>
              <li>🛒 Refill prescriptions and place orders easily</li>
              <li>📦 Track order status and delivery</li>
            </ul>
  
            <div className="store-badges">
              <div className="store-icon">
                <FontAwesomeIcon icon={faGooglePlay} />
                <span>Google Play</span>
              </div>
              <div className="store-icon">
                <FontAwesomeIcon icon={faAppStoreIos} />
                <span>App Store</span>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  };
  
  export default ComingSoonAppSection;